export default __webpack_public_path__ + "static/media/Aval.da0231a3.jpeg";